import * as moment from 'moment';

export class Date {
    year: number;
    month: number;
    day: number;

    constructor (year, month, day) {
      this.year = year;
      this.month = month;
      this.day = day;
    }

    public static today(): Date {
      const today = moment()
      return new Date(today.year(), today.month() + 1, today.date());
    }

    public equals(date: Date): boolean {
      return this.year === date.year && this.month === date.month && this.day === date.day;
    }

    public static toMoment(obj) {
      return moment().year(obj.year).month(obj.month - 1).date(obj.day);
    }
}

export class Time {
  constructor(
    public hour?: number,
    public minute?: number,
    public second?: number,
    public nano?: number
  ) {}

  public static now(): Time {
    const now = moment()
    return new Time(now.hour(), now.minute(), now.second(), now.millisecond());
  }

  public greaterThen(time: Time): boolean {
    if (this.hour > time.hour) {
      return true;
    } else if ( this.hour === time.hour && this.minute > time.minute) {
      return true;
    } else if ( this.hour === time.hour && this.minute === time.minute && this.second > time.second) {
      return true;
    } else if ( this.hour === time.hour && this.minute === time.minute
      && this.second > time.second && this.nano > time.nano) {
        return true;
    }
    return false;
  }

  public lessThen(time: Time): boolean {
    return !this.greaterThen(time);
  }

  public equals(time: Time): boolean {
    return this.hour === time.hour && this.minute === time.minute
            && this.second === time.second && this.nano === this.nano;
  }

  public toEastern(): string {
    return this.hour > 12 ? `${this.hour - 12}:${this.minute <= 9 ? '0': ''}${this.minute}pm` : `${this.hour}:${this.minute <= 9 ? '0': ''}${this.minute}am`;
  }
}

export class Timeline {
    id: number;
    start: Time;
    finish: Time;
}

export class TimelineCounts {
  constructor(
    public solid: number,
    public iffy: number
  ) {}

  get allowed(): number {
    return this.solid != 0 ? this.solid : this.iffy;
  }
}


export class DateTimeFrame {
  dates: Date[];
  timelines: Timeline[];
}



// WEBPACK FOOTER //
// ./src/app/shared/models/date-time.ts